import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { COLLAPSE_PERMISSIONS_ROLE } from "./constants";
export var pt = /*#__PURE__*/_defineProperty({}, COLLAPSE_PERMISSIONS_ROLE, {
  STEP_3_TOOLS_TAG: '{{total}} acesso',
  STEP_3_TABLE_COLUMN_1: 'Ferramenta',
  STEP_3_TABLE_COLUMN_2: 'Configurar e visualizar resultados',
  STEP_3_TABLE_COLUMN_3: 'Ver resultados',
  STEP_3_TABLE_COLUMN_4: 'Sem acesso',
  STEP_3_TABLE_NO_APPLY: 'Não aplicável (não é uma ferramenta editável)'
});